module.exports = __webpack_public_path__ + "img/Sokal-Toyota-SRS-112221-Lifestyle.10044107.jpeg";